import { graphql } from "../gql";

export const FranchiseeFragment = graphql(`
  fragment FranchiseeItem on Franchisee {
    id
    email
    familyName
    givenName
    phoneNumber {
      countryCode
      number
    }
    userGroupIds
    authId
    lesson1on1
    internalTeacher
    roles
    tags
    createdAt
  }
`);
